// extracted by mini-css-extract-plugin
export default {"container":"CreateTeam_container__yKRNx","centered":"CreateTeam_centered__IxGQ6"};